import React, { useState } from "react";
import { FormItemHiddenUi } from "../../ui/FormItemHiddenUi";
import { Button, Col, Form, Input, Row, Space, Tooltip } from "antd";
import { SwitchUi } from "../../ui/SwitchUi";
import { CardUi } from "../../ui/CardUi";
import { useSelector } from "react-redux";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { PerfilesUsuarioDiv } from "./PerfilesUsuarioDiv";
import { AccesosUsuarioDiv } from "./AccesosUsuarioDiv";
import { KeyOutlined } from "@ant-design/icons";
import { ChangePasswordModal } from "./modal/ChangePasswordModal";

export const UsuarioForm = ({ treeData, HandleCloseForm }) => {
  const { activeUsuario } = useSelector((state) => state.usuario);
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  return (
    <>
      <CardUi
        title={
          <Row>
            <Col sm={24} md={12}>
              Usuario
              {activeUsuario ? (
                <small> Editar</small>
              ) : (
                <small> Registrar</small>
              )}
            </Col>
          </Row>
        }
        size="small"
        extra={
          <Space className="site-button-ghost-wrapper" wrap>
            <Tooltip title="Salir">
              <ButtonUi
                typeUi={TipoButtonConstants.Cancelar}
                onClick={HandleCloseForm}
              />
            </Tooltip>
            <Tooltip title="Guardar">
              <ButtonUi
                typeUi={TipoButtonConstants.Guardar}
                htmlType="submit"
              />
            </Tooltip>
          </Space>
        }
      >
        <FormItemHiddenUi name="id" />
        <FormItemHiddenUi name="accesosusuario" />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={24} md={18} lg={18} xl={18}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col xs={24} sm={24} md={12} lg={12} xl={10}>
                <Form.Item
                  label="Usuario"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "El nombre de usuario es obligatorio",
                    },
                  ]}
                >
                  <Input placeholder="Nombre de usuario" maxLength={100} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label="Nombre"
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: "El nombre es obligatorio",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item label="Apellidos" name="last_name">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "El email es obligatorio",
                    },
                    {
                      type: "email",
                      message: "El email es obligatorio",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <PerfilesUsuarioDiv />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <Row gutter={[4, 4]}>
              <CardUi type="inner" size="small">
                <Col span={24}>
                  <Form.Item
                    label="¿Está activo?"
                    name="is_active"
                    valuePropName="checked"
                  >
                    <SwitchUi />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="¿Es super usuario?"
                    name="is_superuser"
                    valuePropName="checked"
                  >
                    <SwitchUi />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="¿Tiene acceso sistema administración?"
                    name="is_staff"
                    valuePropName="checked"
                  >
                    <SwitchUi />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Button
                    variant="outlined"
                    color="cyan"
                    icon={<KeyOutlined />}
                    onClick={handleOpenModal}
                  >
                    Cambiar password
                  </Button>
                </Col>
              </CardUi>
            </Row>
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <AccesosUsuarioDiv treeData={treeData} />
          </Col>
        </Row>
        <ChangePasswordModal
          openModal={openModal}
          handleCancelModal={handleCloseModal}
        />
      </CardUi>
    </>
  );
};
